import axios from "axios";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";

// Added by Gauri on 14 Nov 2025 to get Initiative Link Access details
const GetInitiativeLinkAccess = async (IdeaId, userID, IsConverted) => {
  console.log("GetInitiativeDetail", IdeaId, userID);
  const accessToken = sessionStorage.getItem("access_token");

  try {
    const response = await AxiosInstance1.get(
      `/api/InitiativeDetail/GetInitiativeLinkAccess`,
      {
        params: { IdeaId, userID, IsConverted }   // Added by Gauri on 14 Nov 2025 to get Initiative Link Access details
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching initiative detail:", error);
    throw new Error("Failed to fetch initiative detail");
  }
};

export default GetInitiativeLinkAccess;
